import { View } from 'backbone.marionette';
import template from './index.jst';

export class UpcomingFixturesStatRow extends View {
	get template() {
		return template;
	}

	get className() {
		return 'match-centre-row player-stats-row';
	}

	initialize() {
		this.model.set( {
			'squads_logos': process.env.SQUAD_LOGOS_PATH,
			'has_assistant_coach': this.options.has_assistant_coach
		} );
	}
}

export default UpcomingFixturesStatRow;